import React, { FC } from "react";
import { faSitemap } from "@fortawesome/pro-solid-svg-icons";
import { Box, Tooltip } from "@mantine/core";

import { Transitivity } from "@protos/sca/v1/sca";

import { CodeLocationIcon } from "./CodeLocationIcon";

export type TransitivityIconProps = {
  transitivity: Transitivity;
};

const getTransitivivityIconLabel = (transitivity: Transitivity) => {
  switch (transitivity) {
    case Transitivity.DIRECT: {
      return "Direct";
    }
    case Transitivity.TRANSITIVE: {
      return "Transitive";
    }
  }
  return "Unknown Transitivity";
};

const getTransitivivityIconDescription = (transitivity: Transitivity) => {
  switch (transitivity) {
    case Transitivity.DIRECT: {
      return "Your project depends on the vulnerable package directly";
    }
    case Transitivity.TRANSITIVE: {
      return "Your project depends on the vulnerable package indirectly though multiple steps in its dependency tree";
    }
  }
  return "Semgrep has no data about the transitivity of this vulnerability";
};

export const TransitivityIcon: FC<TransitivityIconProps> = ({
  transitivity,
}) => {
  return (
    <Tooltip
      label={getTransitivivityIconDescription(transitivity)}
      position="bottom"
      withArrow={false}
      withinPortal
    >
      <Box>
        <CodeLocationIcon
          label={getTransitivivityIconLabel(transitivity)}
          icon={faSitemap}
        />
      </Box>
    </Tooltip>
  );
};
